'use strict';

var React = require('react');

var SvgPointOfSaleMajor = function SvgPointOfSaleMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.945 2.438a.5.5 0 0 1 .496-.438h11.119a.5.5 0 0 1 .496.438l.875 7a.5.5 0 0 1-.496.562h-3.245c.198.576.577 1.269 1.24 2h4.07a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-17a1.5 1.5 0 0 1-1.5-1.5v-3a1.5 1.5 0 0 1 1.5-1.5h4.072c.663-.731 1.041-1.424 1.24-2h-3.246a.5.5 0 0 1-.496-.562l.875-7zm1.32 5.562.5-4h8.47l.5 4h-9.47zm5.848 2a6.6 6.6 0 0 0 .824 2h-3.874a6.601 6.601 0 0 0 .824-2h2.226zm-1.113 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }));
};

exports.SvgPointOfSaleMajor = SvgPointOfSaleMajor;
